(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-homepage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.hv-faq-item__button');
    if (!button) return;

    var section = button.closest('.hv-faq');
    var allButtons = section.querySelectorAll('.hv-faq-item__button');
    var isOpen = button.getAttribute('aria-expanded') === 'true';

    /* Close every other item first (accordion behaviour) */
    allButtons.forEach(function (otherBtn) {
      if (otherBtn !== button) {
        otherBtn.setAttribute('aria-expanded', 'false');
        otherBtn.closest('.hv-faq-item')
          .querySelector('.hv-faq-item__panel').hidden = true;
      }
    });

    /* Toggle the clicked item */
    button.setAttribute('aria-expanded', String(!isOpen));
    button.closest('.hv-faq-item')
      .querySelector('.hv-faq-item__panel').hidden = isOpen;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.faq-item__button');
    if (!button) return;

    var item = button.closest('.faq-item');
    var panel = item.querySelector('.faq-item__panel');
    var isOpen = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
